import * as React from "react";
import { type FC } from "react";

import { AddressLevel } from "../../../../FiasInput/Types/FiasTypes";
import { AddressRow } from "../AddressRow";
import { Control } from "../controlsPaths";

interface StructureProps {
    fullSizeAbbreviation: boolean;
    getValue: (control: Control) => string;
    onChange: (control: Control) => (next: string) => void;
}

const addressLevel = AddressLevel.PlanningStructure;
const controlType = Control.StructureType;
const controlName = Control.StructureName;

export const Structure: FC<StructureProps> = props => (
    <AddressRow
        caption={"Элемент планировочной структуры"}
        typePlaceholder={"Тип"}
        namePlaceholder={"Наименование"}
        typeTid={"StructureType"}
        nameTid={"StructureName"}
        fullSizeAbbreviation={props.fullSizeAbbreviation}
        controlType={controlType}
        level={addressLevel}
        type={props.getValue(controlType)}
        name={props.getValue(controlName)}
        onTypeChange={props.onChange(controlType)}
        onNameChange={props.onChange(controlName)}
    />
);
